import React from 'react';
import {RadioButton} from 'primereact/radiobutton';
import './AdminInputRadio.scss';
import AdminFieldLabel from './AdminFieldLabel';

interface RadioOption {
  label: string;
  value: string;
}

interface AdminInputRadioProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: RadioOption[];
  name: string;
  id?: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
}

const AdminInputRadio: React.FC<AdminInputRadioProps> = ({
  label,
  value,
  onChange,
  options,
  name,
  id,
  className = '',
  required = false,
  disabled = false
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      <AdminFieldLabel htmlFor={name} label={label} required={required}/>
      <div className="flex gap-4">
        {options.map((option, index) => (
          <div key={option.value} className="flex items-center">
            <RadioButton
              inputId={id ? `${id}-${option.value}` : `${name}-${option.value}`}
              name={name}
              value={option.value}
              onChange={(e) => onChange(e.value)}
              checked={value === option.value}
              disabled={disabled}
              className="radio-grey"
            />
            <label 
              htmlFor={id ? `${id}-${option.value}` : `${name}-${option.value}`} 
              className="ml-2 text-sm text-gray-700 cursor-pointer"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminInputRadio;
